// card-swiper.js — Product card image Swiper initialization
document.addEventListener('DOMContentLoaded', function() {
  document.querySelectorAll('.pa-card-swiper').forEach(function(cardSwiper) {
    if (cardSwiper.querySelectorAll('.swiper-slide').length <= 1) return;

    var innerSwiper = new Swiper(cardSwiper, {
      slidesPerView: 1,
      spaceBetween: 0,
      pagination: {
        el: cardSwiper.querySelector('.swiper-pagination'),
        clickable: true,
        dynamicBullets: true,
      },
      navigation: {
        nextEl: cardSwiper.querySelector('.swiper-button-next'),
        prevEl: cardSwiper.querySelector('.swiper-button-prev'),
      },
    });

    // Color swatch click — switch to variant image
    var cardProduct = cardSwiper.closest('.pa-card-product');
    if (!cardProduct) return;

    // Hover: switch to second image on mouseenter
    if (cardProduct.dataset.secondaryImage === 'true') {
      var slideCount = cardSwiper.querySelectorAll('.swiper-slide').length;
      if (slideCount > 1) {
        cardProduct.addEventListener('mouseenter', function () {
          innerSwiper.slideTo(1, 300);
        });
        cardProduct.addEventListener('mouseleave', function () {
          innerSwiper.params.speed = 0;
          innerSwiper.slideTo(0, 0);
        });
      }
    }

    var swatches = cardProduct.querySelectorAll('.pa-color-swatch');
    swatches.forEach(function (sw) {
      sw.addEventListener('click', function () {
        var idx = parseInt(this.dataset.slide, 10);
        if (!isNaN(idx) && idx >= 0) {
          innerSwiper.slideTo(idx);
        }
        swatches.forEach(function (s) { s.classList.remove('pa-active'); });
        this.classList.add('pa-active');
      });
    });
  });
});
